// extracted by mini-css-extract-plugin
module.exports = {"xlargeScreen":"1265px","largeScreen":"992px","mediumScreen":"768px","smallScreen":"540px"};